export const INDENTS = { between: 8 };
export const SLIDE_WIDTH = 110;
